<mat-card>
  <mat-card-content fxLayout="column" fxLayoutAlign="space-around stretch">
    <mat-form-field>
      <mat-label>Search</mat-label>
      <input
        matInput
        placeholder=""
        (change)="searchString.emit($event.target.value)"
      />
    </mat-form-field>
    <mat-chip-list
      multiple
      (chipSelectionChanges)="providerTypes.emit(selectedProviderTypes)"
      [selectable]="true"
      class="tag-list"
    >
      <mat-chip
        color="primary"
        *ngFor="let providerType of serviceProviderTypes; let i = index"
        [selected]="providerType.selected"
        (click)="
          providerType.selected = !providerType.selected;
          providerTypes.emit(selectedProviderTypes)
        "
        >{{ providerType.description }}</mat-chip
      >
    </mat-chip-list>
  </mat-card-content>
</mat-card>
